import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import { selectActiveTableRowsCount } from 'services/selectedTableCells/selectors';

interface OwnProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    activeTableRowsCount?: number;
}

type Props = OwnProps & ConnectedProps;

export class SingleActiveTableRowGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { activeTableRowsCount, children } = this.props;

        if (activeTableRowsCount === 1) {
            return children;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    activeTableRowsCount: selectActiveTableRowsCount
});

export default connect(mapStateToProps)(SingleActiveTableRowGateComponent);
